


const EmptyState = ({ icon, title, description, action, className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${className}`}>
      {icon && (
        <div className="mb-3">{typeof icon === "string" ? <img src={icon} alt="" className="w-12 h-12" /> : icon}</div>
      )}
      {title && <p className="text-sm font-medium text-secondary mt-2">{title}</p>}
      {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
